export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/new_codedisplay_1_right.png?191172320d10125d4c134205b903be37";